import { render, staticRenderFns } from "./MyContacts.vue?vue&type=template&id=1909202d&scoped=true&"
import script from "./MyContacts.vue?vue&type=script&setup=true&lang=js&"
export * from "./MyContacts.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1909202d",
  null
  
)

export default component.exports